<template>    
    <div class="container animated fadeIn">
        <div class="row align-items-center">
            <div class="col-md-4 mg-button-invoice">
                <div class="text-center">
                    <ul class="list-group">
                        <li class="list-group-item">
                            <button 
                                type="button" 
                                class="btn btn-info" 
                                style="width: 100%;"
                                @click="$router.go(-1)">
                                Back to vessel
                            </button>
                        </li>
                        <li class="list-group-item">
                            <button @click="generateReport" 
                                type="button" 
                                class="btn btn-info" 
                                style="width: 100%;">
                                Download
                            </button>
                        </li>
                    </ul>
                    <div class="mt-4" v-for="link in invoice.links" :key="link.id">
                        <a :href="link" target="_blank">{{link}}</a>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <Invoice 
                    :invoice="invoice" 
                    :invoice_items="invoice_items" 
                />
            </div>
        </div>
        <!-- Download PDF -->
        <VueHtml2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1200"
            filename="Invoice"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            ref="html2Pdf"
        >
            <section slot="pdf-content">
                <div class="col-md-12 px-4 mt-3">
                    <Invoice 
                        :invoice="invoice" 
                        :invoice_items="invoice_items"
                        :pagination="pagination"
                    />
                </div>
            </section>
        </VueHtml2pdf>
    </div>
</template>

<script>

// Service
import * as invoiceservice from '../services/invoice_service'

// Components
import Invoice from "./Invoice"
import VueHtml2pdf from 'vue-html2pdf'

  export default {

    components: {
        Invoice,
        VueHtml2pdf
    },

    data() {
      return {
        invoice_id : this.$route.params.id,
        invoice : {},
        invoice_items : [],
        pagination : true
      }
    },
  
    mounted() {
        this.getInvoice();

        setInterval(() => {
            this.getInvoice();
        }, 60000);
    },

    methods: {

        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },

        async getInvoice() {
            const user = localStorage.getItem('user');
            const userData = JSON.parse(user);
            const userId = userData.kp_user_id;
           
            try {
                const response = await invoiceservice.getInvoice(this.invoice_id, userId);                            
                if(response.status === 200) {
                    this.invoice = response.data[0];
                    this.invoice_items = response.data[0].invoice_items
                }else {
                    this.$router.back()
                    setTimeout(() => {
                        this.makeToast('Warning', 'The invoice has no items', 'warning');
                    }, 1000)
                }                          
            } catch (error) {
                console.log(error);
            }          
        },

        makeToast(title, text, type) {
            this.toastCount++
            this.$bvToast.toast(text, {
                title: title,
                variant: type,
                autoHideDelay: 2000,
                appendToast: true
            })
        },
    }

  }
</script>